import { GET_CONFIG_DETAILS } from "./type"; // Fixed import

export const getConfigdetails = (data) => {
  return {
    type: GET_CONFIG_DETAILS,
    payload: data,
  };
};
